import swal from 'sweetalert';

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.js-destroy').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            var href = this.getAttribute('href');

            swal({
                title: "Weet je het zeker?",
                text: "Deze actie kan niet ongedaan gemaakt worden.",
                icon: "error",
                dangerMode: true,
                buttons: ["Annuleren", {
                    text: "Verwijderen",
                    closeModal: false
                }],
            }).then((willDelete) => {
                if (willDelete) {
                    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                    var form = document.createElement('form');
                    form.id = 'destroy';
                    form.method = 'POST';
                    form.action = href;
                    form.innerHTML = '<input type="hidden" id="_token" name="_token" value="' + csrfToken + '">' +
                        '<input type="hidden" id="_method" name="_method" value="DELETE">';

                    document.body.appendChild(form);

                    form.submit();
                }
            });
        });
    });
});
